 import React from 'react';
import { useParams, Link } from 'react-router-dom';
import {
  Wrench, Lightbulb, Package, Truck, BatteryCharging, Users,
  ArrowLeft, Phone, Clock, Shield, Star, CheckCircle
} from 'lucide-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import SEO from '../../components/SEO';
import NotFound from '../notFound/NotFound';
import { toArabicSlug } from '../../data/areaSlugMapping';
import './ServiceDetail.css';
import img1 from '../../images/images.webp';
import img2 from '../../images/images (1).webp';
import img3 from '../../images/fuel.webp';
import img4 from '../../images/download.webp';
import img5 from '../../images/battary.webp';
import img6 from '../../images/download (2).webp';

const services = {
  rescue: {
    icon: <Wrench size={44} color="#0077ff" style={{ marginBottom: '1rem' }} />,
    title: 'إنقاذ وسحب السيارات',
    desc: 'خدمة إنقاذ وسحب السيارات المتكاملة على مدار الساعة 24/7 في كافة محافظات مصر والمحاور السريعة. سواء تعرضت لعطل ميكانيكي أو كهربائي مفاجئ أو حادث تصادم، فإن أسطول أوناش محمد بحر المنتشر في جميع الميادين جاهز للوصول إليك خلال 10 إلى 15 دقيقة فقط. نعتمد على أحدث أوناش الرفع الهيدروليكي المسطح (Flatbed) وأوناش السحب الجزئي لحماية سيارتك بالكامل ومنع أي احتكاك أثناء الرفع والنقل.',
    image: img1,
    sla: '10–15 دقيقة داخل القاهرة والجيزة، 15–20 دقيقة على الطرق السريعة',
    steps: [
      'استقبال البلاغ وتحديد موقعك الدقيق عبر الـ GPS أو تطبيق واتساب',
      'توجيه أقرب ونش إنقاذ متمركز في منطقتك فوراً',
      'تأمين موقع السيارة ورفعها باستخدام أحزمة هيدروليكية معتمدة دون ملامسة الصدادات',
      'نقل السيارة بأمان تام إلى الوجهة المحددة أو مركز الصيانة المعتمد'
    ],
    equipmentSpecs: [
      'أوناش هيدروليكية كاملة الانخفاض (Zero-degree Floorbed) للسيارات الرياضية والمنخفضة',
      'روافع هيدروليكية بطاقة رفع تصل إلى 5 أطنان للمركبات الـ SUV والشاحنات الصغيرة',
      'أحزمة ربط قماشية مدعمة بنظام الشد المزدوج لمنع أي انزلاق',
      'أنظمة إضاءة تحذيرية متطورة لتأمين العمل الليلي على الطرق السريعة'
    ],
    more: [
      'خدمة متاحة 24 ساعة يومياً طوال أيام الأسبوع بما في ذلك الأعياد والعطلات الرسمية',
      'خصم فوري 50% على تكلفة السحب مع تسعيرة ثابتة بدون رسوم خفية أو إكراميات',
      'تأمين شامل على سلامة هيكل السيارة والمكونات السفلية أثناء النقل',
      'إمكانية سحب السيارات من المواقف الضيقة والجراجات تحت الأرض بأوناش مخصصة'
    ],
    relatedAreas: ["المعادي", "مدينة نصر", "مصر الجديدة", "التجمع الخامس", "الإسكندرية", "6 أكتوبر", "الساحل الشمالي", "الشيخ زايد"],

  },
  equipment: {
    icon: <Lightbulb size={44} color="#0077ff" style={{ marginBottom: '1rem' }} />,
    title: 'نقل المعدات والآلات الثقيلة',
    desc: 'خدمة متخصصة واحترافية لنقل المعدات الثقيلة، الكرفانات، المولدات الكهربائية، اللوادر، وآلات المصانع والمواقع الإنشائية في جميع محافظات مصر. نمتلك أسطولاً من سيارات النقل والسطحات الثقيلة المجهزة بأنظمة تثبيت هيدروليكية ومعدات ربط ذات حمولات عالية تضمن وصول معداتك بأمان تام وفي المواعيد المحددة.',
    image: img2,
    sla: 'حجز فوري واستجابة خلال 30–45 دقيقة للمعدات والسطحات الثقيلة',
    steps: [
      'معاينة أبعاد ووزن المعدة لاختيار السطحة المناسبة',
      'تحميل وتثبيت المعدة بواسطة سلاسل وأحزمة تثبيت فائقة القوة',
      'تحديد المسار المروري الأنسب والآمن وتفادي الكباري المنخفضة',
      'تفريغ المعدة في الموقع بدقة متناهية تحت إشراف فنيين مختصين'
    ],
    equipmentSpecs: [
      'سطحات نقل ثقيلة بحمولات تتراوح من 10 أطنان حتى 30 طناً',
      'أنظمة ونش هيدروليكي قوي للسحب الذاتي للمعدات المعطلة',
      'سلاسل ربط فولاذية معتمدة وفق أعلى معايير السلامة الصناعية'
    ],
    more: [
      'تغطية شاملة لجميع المناطق الصناعية: 6 أكتوبر، العاشر من رمضان، السادات، والعاصمة الإدارية',
      'تأمين شامل على المعدات والبضائع المنقولة طوال فترة الرحلة',
      'عقود شهرية وسنوية ميسرة للشركات والمصانع والمقاولين'
    ],
    relatedAreas: ["المعادي", "مدينة نصر", "مصر الجديدة", "التجمع الخامس", "الإسكندرية", "6 أكتوبر", "الساحل الشمالي", "الشيخ زايد"],

  },
  fuel: {
    icon: <Package size={44} color="#0077ff" style={{ marginBottom: '1rem' }} />,
    title: 'التزود بوقود الطوارئ على الطريق',
    desc: 'لا تدع نفاد الوقود يعطل رحلتك! نقدم خدمة توصيل وتزويد الوقود (بنزين 92، بنزين 95، سولار) في الموقع مباشرة لجميع السيارات العالقة على الطرق السريعة وداخل المدن. نصل إليك بعبوات وقود آمنة ومطابقة للمواصفات لتمكينك من استئناف رحلتك والوصول لأقرب محطة وقود دون الحاجة لترك سيارتك.',
    image: img3,
    sla: '10–20 دقيقة داخل المدن والطرق الدائرية',
    steps: [
      'الاتصال وتحديد نوع الوقود المطلوب (بنزين 92/95 أو سولار) والموقع',
      'تحرك وحدة الدعم السريع مع الوقود المطلوب في عبوات محكمة الغلق',
      'تزويد خزان السيارة بالوقود وتشغيل المحرك والاطمئنان على دورة الوقود'
    ],
    equipmentSpecs: [
      'جالونات وقود معدنية معتمدة ضد الشرر والتسريب',
      'مضخات تفريغ يدوية وكهربائية آمنة تمنع انسكاب الوقود على طلاء السيارة'
    ],
    more: [
      'خدمة طوارئ سريعة تعمل على مدار 24 ساعة طوال أيام الأسبوع',
      'سعر الوقود بالسعر الرسمي المعلن من وزارة البترول بدون زيادة',
      'فحص مجاني سريع لضغط الإطارات ومستوى سائل التبريد أثناء التزود'
    ],
    relatedAreas: ["المعادي", "مدينة نصر", "مصر الجديدة", "التجمع الخامس", "الإسكندرية", "6 أكتوبر", "الساحل الشمالي", "الشيخ زايد"],

  },
  unlock: {
    icon: <Truck size={44} color="#0077ff" style={{ marginBottom: '1rem' }} />,
    title: 'فتح أبواب السيارات المغلقة',
    desc: 'خدمة احترافية لفتح أبواب السيارات المقفلة ونسيان المفتاح بالداخل دون إحداث أي خدش للطلاء أو تلف في زجاج السيارة أو نظام القفل المركزي (السنترلوك). يستخدم خبراؤنا أدوات هوائية ناعمة وتقنيات غير تدميرية تناسب أحدث السيارات الألمانية، اليابانية، والكورية.',
    image: img4,
    sla: '15–20 دقيقة في كافة المناطق الحضرية',
    steps: [
      'التحقق من إثبات ملكية السيارة لحماية العميل',
      'استخدام الوسائد الهوائية الدقيقة لفتح مسافة آمنة دون ثني الباب',
      'سحب قفل الأمان بأدوات ألياف ناعمة مخصصة',
      'اختبار عمل المفتاح والقفل والتأكد من سلامة النظام الإلكتروني'
    ],
    equipmentSpecs: [
      'وسائد هوائية من ألياف البولي يوريثان لحماية إطارات الأبواب',
      'أدوات فتح متقدمة متوافقة مع أنظمة الأمان المتطورة (Keyless & Push Button)'
    ],
    more: [
      'ضمان عدم حدوث أي انبعاج أو تسريب هواء أو ماء في جوان الباب',
      'جاهزون للتعامل مع سيارات مرسيدس، بي إم دبليو، أودي، رينج روفر، وكافة الماركات'
    ],
    relatedAreas: ["المعادي", "مدينة نصر", "مصر الجديدة", "التجمع الخامس", "الإسكندرية", "6 أكتوبر", "الساحل الشمالي", "الشيخ زايد"],
  },
  battery: {
    icon: <BatteryCharging size={44} color="#0077ff" style={{ marginBottom: '1rem' }} />,
    title: 'شحن بطاريات وتوصيل وصلة كهرباء',
    desc: 'خدمة إنعاش وشحن بطاريات السيارات المتوقفة في الموقع أو الجراجات بواسطة أجهزة شحن ذكية وكابلات نحاسية معزولة عالية القدرة تحمي كمبيوتر السيارة والدوائر الإلكترونية الحساسة من أي تيار زائد. كما نوفر خدمة فحص دينامو السيارة واستبدال البطارية بأخرى جديدة أصلية بضمان معتمد.',
    image: img5,
    sla: '10–15 دقيقة للوصول وبدء التشغيل الفوري',
    steps: [
      'فحص جهد البطارية بجهاز اختبار رقمي لتحديد سبب العطل (شحن منخفض أم تلف تام)',
      'توصيل كابلات الشحن الذكية المعزولة بأمان تام',
      'تشغيل محرك السيارة واختبار كفاءة شحن الدينامو',
      'تقديم تقرير فني للعميل عن العمر الافتراضي المتبقي للبطارية'
    ],
    equipmentSpecs: [
      'أجهزة Jump Starter متطورة بتيار بدء تشغيل يصل إلى 2000 أمبير',
      'أجهزة فحص جهد إلكترونية تكشف كفاءة الشحن وحالة الخلايا'
    ],
    more: [
      'كابلات معزولة بالكامل مزودة بصمامات حماية ضد عكس الأقطاب',
      'إمكانية توريد وتركيب بطاريات جديدة (كلورايد، فارتا، إيه سي ديلكو) مع استبدال القديمة'
    ],
    relatedAreas: ["المعادي", "مدينة نصر", "مصر الجديدة", "التجمع الخامس", "الإسكندرية", "6 أكتوبر", "الساحل الشمالي", "الشيخ زايد"],

  },
  tires: {
    icon: <Users size={44} color="#0077ff" style={{ marginBottom: '1rem' }} />,
    title: 'تغيير وإصلاح الإطارات على الطريق',
    desc: 'خدمة تبديل الإطار التالف بالإطار الاحتياطي (الاستبن) أو إصلاح الثقوب البسيطة في الموقع على مدار 24 ساعة. نوفر رافعات هيدروليكية سريعة ومفكات عزم هوائية لفك وتركيب صواميل العجلات بدقة وأمان تام دون إتلاف الجنوط أو مسامير العجل.',
    image: img6,
    sla: '10–15 دقيقة في المدن والمحاور الرئيسية',
    steps: [
      'تأمين موقع السيارة بوضع مثلث التحذير وتشغيل الفلاشر',
      'رفع جانب السيارة بروافع هيدروليكية آمنة',
      'فك الإطار التالف وتركيب الاستبن وضبط ضغط الهواء بضاغط هواء رقمي',
      'التأكد من عزم ربط الصواميل واختبار ثبات العجلة'
    ],
    equipmentSpecs: [
      'روافع هيدروليكية مدمجة ومفكات صواميل هوائية عالية العزم',
      'ضواغط هواء متنقلة رقمية لضبط ضغط الإطارات بدقة وفق كتالوج السيارة'
    ],
    more: [
      'فحص شامل لحالة بقية إطارات السيارة لضمان القيادة الآمنة',
      'متخصصون في إطارات Run-Flat وإطارات السيارات الرياضية ذات الجنوط الكبيرة'
    ],
    relatedAreas: ["المعادي", "مدينة نصر", "مصر الجديدة", "التجمع الخامس", "الإسكندرية", "6 أكتوبر", "الساحل الشمالي", "الشيخ زايد"],

  }
};

const ServiceDetail = () => {
  const { serviceId } = useParams();
  const service = services[serviceId];

  // Scroll to top when component mounts
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [serviceId]);
  const phone = '01044844492';

  if (!service) {
    return <NotFound />;
  }

  const features = [
    {
      icon: <Clock size={24} color="#ffc107" />,
      title: "استجابة سريعة",
      description: "وصول خلال 15-30 دقيقة"
    },
    {
      icon: <Shield size={24} color="#ffc107" />,
      title: "أمان تام",
      description: "معدات حديثة وطاقم مدرب"
    },
    {
      icon: <Star size={24} color="#ffc107" />,
      title: "خبرة 30 عام",
      description: "خبرة طويلة في مجال الإنقاذ"
    },
    {
      icon: <CheckCircle size={24} color="#ffc107" />,
      title: "ضمان الجودة",
      description: "خدمة مضمونة بجودة عالية"
    }
  ];

  return (
    <section style={{
      minHeight: '100vh',
      background: '#f7f7f7',
      fontFamily: 'Tajawal, Arial, sans-serif',
    }}>
      <SEO
        title={`${service.title} | خدمة 24 ساعة في جميع محافظات مصر`}
        description={`${service.title} من ونش انقاذ محمد بحر: ${service.desc.slice(0, 120)}... خدمة سريعة وموثوقة على مدار الساعة. اتصل الآن 01044844492`}
        path={`/service/${serviceId}`}
        type="service"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Service",
          name: service.title,
          description: service.desc.slice(0, 300),
          provider: {
            "@type": "AutomotiveBusiness",
            name: "ونش انقاذ سيارات محمد بحر",
            telephone: "+201044844492",
            url: "https://winchmohamedbahr.com/",
          },
          areaServed: { "@type": "Country", name: "مصر" },
          url: `https://winchmohamedbahr.com/service/${serviceId}`,
        }}
      />
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>

        {/* Header Section */}
        <div style={{
          background: 'linear-gradient(135deg, #0a2c61 0%, #1976d2 100%)',
          color: 'white',
          borderRadius: '1.5rem',
          padding: '3rem 2rem',
          marginBottom: '2rem',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
          marginTop: '2rem'
        }}>
          <div style={{
            position: 'absolute',
            top: '1rem',
            right: '1rem',
            background: '#ffc107',
            color: '#0a2c61',
            fontWeight: 900,
            fontSize: '1rem',
            borderRadius: '1rem',
            padding: '0.3rem 1rem',
          }}>
            خدمة 24/7
          </div>

          <Link to="/services" style={{
            position: 'absolute',
            top: '1rem',
            left: '1rem',
            color: 'white',
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            fontSize: '1rem',
            fontWeight: 600
          }}>
            <ArrowLeft size={20} />
            العودة للخدمات
          </Link>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '1rem',
            marginBottom: '1rem'
          }}>
            {service.icon}
          </div>

          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: 900,
            marginBottom: '1rem',
            direction: 'rtl'
          }}>
            {service.title}
          </h1>

          <p style={{
            fontSize: '1.2rem',
            opacity: 0.9,
            maxWidth: '600px',
            margin: '0 auto',
            direction: 'rtl'
          }}>
            خدمة متخصصة ومتقدمة لجميع احتياجاتك
          </p>
        </div>

        {/* Main Content Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '2rem',
          marginBottom: '2rem'
        }}>

          {/* Service Description */}
          <div style={{
            background: 'white',
            borderRadius: '1.5rem',
            padding: '2rem',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            border: '2px solid #e3f0ff'
          }}>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 800,
              color: '#0a2c61',
              marginBottom: '1.5rem',
              textAlign: 'center',
              direction: 'rtl'
            }}>
              تفاصيل الخدمة
            </h2>

            <div style={{
              background: '#f8f9fa',
              padding: '1.5rem',
              borderRadius: '1rem',
              border: '1px solid #e9ecef',
              direction: 'rtl',
              fontSize: '1.1rem',
              lineHeight: 1.8,
              color: '#0a2c61'
            }}>
              {service.desc}
            </div>
          </div>

          {/* Service Image */}
          <div style={{
            background: 'white',
            borderRadius: '1.5rem',
            padding: '2rem',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            border: '2px solid #e3f0ff',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 800,
              color: '#0a2c61',
              marginBottom: '1.5rem',
              textAlign: 'center',
              direction: 'rtl'
            }}>
              صور الخدمة
            </h2>

            <img
              src={service.image}
              alt={service.title}
              style={{
                width: '100%',
                maxWidth: '400px',
                borderRadius: '1rem',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                transition: 'transform 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'scale(1.05)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'scale(1)';
              }}
            />
          </div>
        </div>

        {/* Features Section */}
        <div style={{
          background: 'white',
          borderRadius: '1.5rem',
          padding: '2rem',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          marginBottom: '2rem',
          border: '2px solid #e3f0ff'
        }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: 800,
            color: '#0a2c61',
            marginBottom: '1.5rem',
            textAlign: 'center',
            direction: 'rtl'
          }}>
            مميزات الخدمة
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '1.5rem'
          }}>
            {features.map((feature, index) => (
              <div key={index} style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                padding: '1.5rem',
                borderRadius: '1rem',
                background: '#f8f9fa',
                border: '1px solid #e9ecef',
                transition: 'all 0.3s ease'
              }}
                onMouseOver={(e) => {
                  e.target.style.background = '#e3f0ff';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseOut={(e) => {
                  e.target.style.background = '#f8f9fa';
                  e.target.style.transform = 'translateY(0)';
                }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: 'white',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}>
                  {feature.icon}
                </div>
                <div style={{ flex: 1, direction: 'rtl' }}>
                  <div style={{
                    fontWeight: 700,
                    color: '#0a2c61',
                    fontSize: '1.1rem',
                    marginBottom: '0.3rem'
                  }}>
                    {feature.title}
                  </div>
                  <div style={{
                    color: '#6c757d',
                    fontSize: '0.9rem'
                  }}>
                    {feature.description}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Service Details */}
        <div style={{
          background: 'white',
          borderRadius: '1.5rem',
          padding: '2rem',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          marginBottom: '2rem',
          border: '2px solid #e3f0ff'
        }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: 800,
            color: '#0a2c61',
            marginBottom: '1.5rem',
            textAlign: 'center',
            direction: 'rtl'
          }}>
            تفاصيل إضافية
          </h2>

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
          }}>
            {service.more && service.more.map((detail, idx) => (
              <div key={idx} style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '1rem',
                padding: '1.5rem',
                borderRadius: '1rem',
                background: '#f8f9fa',
                border: '1px solid #e9ecef',
                transition: 'all 0.3s ease'
              }}
                onMouseOver={(e) => {
                  e.target.style.background = '#e3f0ff';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseOut={(e) => {
                  e.target.style.background = '#f8f9fa';
                  e.target.style.transform = 'translateY(0)';
                }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  background: '#0077ff',
                  color: 'white',
                  fontSize: '1.2rem',
                  fontWeight: 'bold',
                  flexShrink: 0
                }}>
                  ✓
                </div>
                <div style={{
                  flex: 1,
                  direction: 'rtl',
                  fontSize: '1.05rem',
                  color: '#0a2c61',
                  lineHeight: 1.6
                }}>
                  {detail}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Workflow Steps Section */}
        {service.steps && service.steps.length > 0 && (
          <div style={{
            background: 'white',
            borderRadius: '1.5rem',
            padding: '2rem',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            marginBottom: '2rem',
            border: '2px solid #e3f0ff',
            direction: 'rtl'
          }}>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 800,
              color: '#0a2c61',
              marginBottom: '1.5rem',
              textAlign: 'center'
            }}>
              📋 مراحل وخطوات تنفيذ الخدمة
            </h2>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
              gap: '1.2rem'
            }}>
              {service.steps.map((step, idx) => (
                <div key={idx} style={{
                  background: '#f8f9fa',
                  padding: '1.2rem',
                  borderRadius: '1rem',
                  border: '1px solid #e9ecef',
                  position: 'relative'
                }}>
                  <div style={{
                    display: 'inline-block',
                    background: '#0077ff',
                    color: 'white',
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    textAlign: 'center',
                    lineHeight: '32px',
                    fontWeight: 'bold',
                    marginBottom: '0.8rem'
                  }}>
                    {idx + 1}
                  </div>
                  <p style={{ margin: 0, fontSize: '1.05rem', color: '#0a2c61', lineHeight: 1.7 }}>
                    {step}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Equipment Specs Section */}
        {service.equipmentSpecs && service.equipmentSpecs.length > 0 && (
          <div style={{
            background: 'white',
            borderRadius: '1.5rem',
            padding: '2rem',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            marginBottom: '2rem',
            border: '2px solid #e3f0ff',
            direction: 'rtl'
          }}>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 800,
              color: '#0a2c61',
              marginBottom: '1.5rem',
              textAlign: 'center'
            }}>
              ⚙️ المواصفات الفنية والمعدات المعتمدة
            </h2>

            <ul style={{
              background: '#f8f9fa',
              padding: '1.5rem',
              borderRadius: '1rem',
              border: '1px solid #e9ecef',
              margin: 0,
              lineHeight: 1.9,
              fontSize: '1.05rem',
              color: '#0a2c61'
            }}>
              {service.equipmentSpecs.map((spec, idx) => (
                <li key={idx} style={{ marginBottom: '0.6rem' }}>
                  {spec}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Related Areas (T070) */}
        {service.relatedAreas && service.relatedAreas.length > 0 && (
          <div className="related-areas-section" style={{
            background: 'white', borderRadius: '1.5rem', padding: '2rem',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)', marginBottom: '2rem', border: '2px solid #e3f0ff'
          }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 800, color: '#0a2c61', marginBottom: '1rem', textAlign: 'center', direction: 'rtl' }}>
              الخدمة متاحة في هذه المناطق
            </h2>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', direction: 'rtl', justifyContent: 'center' }}>
              {service.relatedAreas.map((a, i) => (
                <Link key={i} to={`/areas/${toArabicSlug(a)}`} style={{
                  background: '#0a2c61', color: 'white', padding: '0.4rem 0.9rem',
                  borderRadius: '0.5rem', textDecoration: 'none', fontSize: '0.9rem', fontWeight: 600
                }}>
                  ونش {a}
                </Link>
              ))}
            </div>
          </div>
        )}

        {/* Contact Section */}
        <div style={{
          background: 'white',
          borderRadius: '1.5rem',
          padding: '2rem',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          marginBottom: '2rem',
          border: '2px solid #e3f0ff'
        }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: 800,
            color: '#0a2c61',
            marginBottom: '1.5rem',
            textAlign: 'center',
            direction: 'rtl'
          }}>
            احصل على الخدمة الآن
          </h2>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <a
              href={`tel:${phone}`}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                padding: '1rem',
                borderRadius: '1rem',
                background: '#f8f9fa',
                textDecoration: 'none',
                color: 'inherit',
                transition: 'all 0.3s ease',
                border: '1px solid #e9ecef'
              }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                background: 'white',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}>
                <Phone size={24} color="#0077ff" />
              </div>
              <div style={{ flex: 1, direction: 'rtl' }}>
                <div style={{
                  fontWeight: 700,
                  color: '#0a2c61',
                  fontSize: '1.1rem',
                  marginBottom: '0.2rem'
                }}>
                  الهاتف الرئيسي
                </div>
                <div style={{
                  color: '#0077ff',
                  fontWeight: 600,
                  fontSize: '1rem'
                }}>
                  {phone}
                </div>
                <div style={{
                  color: '#6c757d',
                  fontSize: '0.9rem',
                  marginTop: '0.2rem'
                }}>
                  اتصل بنا على مدار الساعة
                </div>
              </div>
            </a>
            <a
              href={`tel:+201034222636`}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                padding: '1rem',
                borderRadius: '1rem',
                background: '#f8f9fa',
                textDecoration: 'none',
                color: 'inherit',
                transition: 'all 0.3s ease',
                border: '1px solid #e9ecef'
              }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                background: 'white',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}>
                <Phone size={24} color="#0077ff" />
              </div>
              <div style={{ flex: 1, direction: 'rtl' }}>
                <div style={{
                  fontWeight: 700,
                  color: '#0a2c61',
                  fontSize: '1.1rem',
                  marginBottom: '0.2rem'
                }}>
                  الطوارئ و خدمة العملاء
                </div>
                <div style={{
                  color: '#0077ff',
                  fontWeight: 600,
                  fontSize: '1rem'
                }}>
                  01034222636
                </div>
                <div style={{
                  color: '#6c757d',
                  fontSize: '0.9rem',
                  marginTop: '0.2rem'
                }}>
                  اتصل بنا على مدار الساعة
                </div>
              </div>
            </a>

            <a
              href={`https://wa.me/201044844492`}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                padding: '1rem',
                borderRadius: '1rem',
                background: '#f8f9fa',
                textDecoration: 'none',
                color: 'inherit',
                transition: 'all 0.3s ease',
                border: '1px solid #e9ecef'
              }}

            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                background: 'white',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}>
                <FontAwesomeIcon icon={faWhatsapp} size="lg" style={{ color: "#25D366" }} />
              </div>
              <div style={{ flex: 1, direction: 'rtl' }}>
                <div style={{
                  fontWeight: 700,
                  color: '#0a2c61',
                  fontSize: '1.1rem',
                  marginBottom: '0.2rem'
                }}>
                  واتساب
                </div>
                <div style={{
                  color: '#25D366',
                  fontWeight: 600,
                  fontSize: '1rem'
                }}>
                  {phone}
                </div>
                <div style={{
                  color: '#6c757d',
                  fontSize: '0.9rem',
                  marginTop: '0.2rem'
                }}>
                  راسلنا على واتساب
                </div>
              </div>
            </a>
          </div>
        </div>

        {/* Emergency Contact */}
        <div style={window.innerWidth > 768 ? {
          background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
          color: 'white',
          borderRadius: '1.5rem',
          padding: '2rem',
          textAlign: 'center',
          boxShadow: '0 4px 20px rgba(220,53,69,0.3)',
          marginBottom: '2rem',
        } : {
          background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
          color: 'white',
          borderRadius: '1.5rem',
          padding: '2rem',
          textAlign: 'center',
          boxShadow: '0 4px 20px rgba(220,53,69,0.3)',
          marginBottom: '4rem',
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '1rem',
            marginBottom: '1rem'
          }}>
            <Shield size={32} />
            <h3 style={{
              fontSize: '1.5rem',
              fontWeight: 800,
              margin: 0
            }}>
              طوارئ؟
            </h3>
          </div>

          <p style={{
            fontSize: '1.1rem',
            marginBottom: '1.5rem',
            direction: 'rtl'
          }}>
            اتصل بنا فوراً للحصول على خدمة {service.title} سريعة
          </p>

          <a
            href={`tel:${phone}`}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              background: 'white',
              color: '#dc3545',
              padding: '1rem 2rem',
              borderRadius: '0.5rem',
              textDecoration: 'none',
              fontWeight: 700,
              fontSize: '1.2rem',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'scale(1.05)';
              e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'scale(1)';
              e.target.style.boxShadow = 'none';
            }}
          >
            <Phone size={24} />
            {phone}
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServiceDetail; 